export default __webpack_public_path__ + "static/media/211.e9a270c5.jpg";